import { executeRequest, JFSRequest } from '@jfs/network'
import { RootStore } from '../data/store'
import { isSuccessResponse } from '../utils'
import { APIEndPoints } from './APIEndPoints'
import { getHeaders, getUrl, sitConfig } from './config'
import { parseEntityItem } from './getGlobalEntityQueue'

const responseParser = (response: any, ddData: any) => {
  const data = isSuccessResponse(response)
  return {
    processInstances: data?.processInstances?.map((processInstance) => ({
      ...parseEntityItem(processInstance?.state, ddData),
      state: processInstance?.state,
      errorMessage: processInstance?.incident?.value?.errorMessage,
      jobKey: processInstance?.incident?.value?.jobKey,
      incidentId: processInstance?.incident?.key,
    })),
    pagination: {
      size: data?.pageSize,
      totalElements: data?.totalItems ?? 0,
      number: data?.pageNumber + 1,
      totalPages: Math.ceil(data?.totalItems / data?.pageSize),
    },
  }
}

const getOnboardingIncidents = (ddData: any, pageNumber: number, pageSize: number) => {
  const request: JFSRequest<{}> = {
    apiPath: getUrl(APIEndPoints.getOnboardingIncidents),
    method: 'POST',
    config: sitConfig(RootStore.session.getTokens),
    headers: getHeaders(),
    body: {
      pageNumber,
      pageSize,
    },
  }

  return executeRequest(request)
    .then((resp) => responseParser(resp, ddData))
    .catch((error) => {
      throw error
    })
}

export { getOnboardingIncidents }
